module.exports = __webpack_public_path__ + "img/zhu_zc_liuziyang.fb43f1da.jpg";